/**
 * FE-C2g batch-8: Live ops dashboard — contract paths for #/ops-live.
 */

import { buildContractPath } from "./api/contract-client.js";

export const OPS_METRICS_CONSOLE_TIMEOUT_MS = 15000;

/** @param {string} [scope] */
export function buildAdminOpsGlobalMetricsPath(scope) {
  const query = scope ? { scope } : undefined;
  return buildContractPath("get__admin_ops_global-metrics", { query });
}

/**
 * @param {{ interval_ms?: number, scope?: string }} [opts]
 */
export function buildAdminOpsGlobalMetricsStreamPath(opts = {}) {
  const query = {};
  if (opts.interval_ms != null) query.interval_ms = opts.interval_ms;
  if (opts.scope) query.scope = opts.scope;
  return buildContractPath("get__admin_ops_global-metrics_stream", {
    query: Object.keys(query).length ? query : undefined,
  });
}

/** Bounded structured log tail — superadmin / sa_security_admin. */
export function buildGetLogsFilePath(query = {}) {
  return buildContractPath("get__logs_file", { query });
}

/** Dedicated FCM topic migration health (bindings + counters + flags). */
export function buildGetAdminFcmTopicMigrationHealthPath() {
  return buildContractPath("get__admin_fcm_topic-migration-health");
}
